export const environment = {
  apiUrl: 'https://tst-elciaerp-api-c8d7f3hadjg9behv.francecentral-01.azurewebsites.net',
  production: true,
};
